import styled from 'styled-components/macro'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'

export const ContactsContainer = styled.div`
  border-radius: var(--border-radius);
  background: #ffedf4;
  padding: 12px var(--spacing-sm);
  margin: auto;
  font-style: italic;
  font-weight: 300;
  ${theme.shadow()};

  ${mq.small} {
    padding: 8px var(--spacing-sm);
  }
  ${mq.medium} {
    padding: 10px var(--spacing-sm);
  }
`
